/**
 * @file
 * A JavaScript file for the theme.
 *
 * In order for this JavaScript to be loaded on pages, see the instructions in
 * the README.txt next to this file.
 */

(function ($) {
  $(document).ready(function () {
    // Load Typekit
    try {Typekit.load();}
    catch(e) {}
    
    $(document.body).on('click', '.social-share-wrapper .permalink-share', function () {
      const textElem = document.createElement('textarea');
      textElem.style.position = 'fixed';
      textElem.style.left = '0';
      textElem.style.top = '0';
      textElem.style.opacity = '0';
      textElem.value = window.location;
      document.body.appendChild(textElem);
      textElem.focus();
      textElem.select();
      textElem.setSelectionRange(0, 99999); // for mobile compatibility
      document.execCommand('copy');
      document.body.removeChild(textElem);

      $('.social-share-wrapper .toast').toast('show');
    });

    findPageHeroHighlights();
        
    $(".btn.dropdown-toggle").on("click", function () {
      const same = $(this).closest('.dropdown').find('.dropdown-menu').hasClass("show");
      $(".dropdown .dropdown-menu.show").removeClass("show");
      $(".dropdown.show").removeClass("show");

      if (!same) {
        $(this).closest('.dropdown').find('.dropdown-menu').addClass("show");
        $(this).closest('.dropdown').addClass("show");
      }
    });

    function findPageHeroHighlights() {
      const pageHeroHighlights = [
        {
          title: 'Presidential Voter Guide',
          highlight: 'Voter Guide'
        },
      ];
      const pageHeroDOMSelector = '.header-content h1';
      const titleContent = $(pageHeroDOMSelector).text().toLowerCase().trim();
      const highlightMatch = pageHeroHighlights.find(hero => hero.title.trim().toLowerCase() == titleContent);
  
      if (highlightMatch) {
        $(pageHeroDOMSelector).html(function(_, html) {
          const regex = new RegExp("(" + highlightMatch.highlight + ")", "g");
          return html.replace(regex, '<span>$1</span>');
        });
      }
    }
  });
}(jQuery));
